'use client';

import { useMyPlannerDayCounsels } from '@/entities/visit-counsel/model/useMyPlannerDayCounsels';
import { useMyPlannerDayAssignedRegionIds } from '@/entities/planner/model/useMyPlannerDayAssignedRegionIds';
import { useMyPlannerWorkScheduleDates } from '@/entities/planner/model/useMyPlannerWorkScheduleDates';
import { useGeoJsonByServiceRegionIds } from '@/entities/legal-region/model/useGeoJsonByServiceRegionIds';
import { useServiceRegions } from '@/entities/service-region/model/useServiceRegions';
import type { PlannerScheduleData } from '@/widgets/planner/planner-schedule-tab/model/plannerScheduleData.types';
import type { PlannerDayCounselByPlanner } from '@/entities/visit-counsel/model/usePlannerDayCounselsByPlanner';

/**
 * 플래너 전용: 내 일정 데이터
 * /api/v1/planners/me, /api/v1/visit-counsels/* API 사용
 * @param plannerId - counselorId 필터 (서버 자동 주입이 안 될 때 FE에서 명시 전달)
 */
export function usePlannerScheduleDataByMe(
  selectedDate: string,
  plannerId?: string
): PlannerScheduleData {
  const enabled = !!selectedDate;

  const {
    counsels: counselsMy,
    isLoading,
    error,
  } = useMyPlannerDayCounsels(selectedDate, enabled, plannerId);
  const { regionIds, isLoading: regionIdsLoading } = useMyPlannerDayAssignedRegionIds(
    selectedDate,
    enabled
  );
  const { workDates, isLoaded: isWorkDatesLoaded } = useMyPlannerWorkScheduleDates(
    selectedDate,
    enabled
  );
  const { geoJson, isLoading: geoJsonLoading } = useGeoJsonByServiceRegionIds(
    regionIds,
    regionIds.length > 0
  );
  const { serviceRegions, isLoading: serviceRegionsLoading } = useServiceRegions({
    ids: regionIds,
  });

  const counsels: PlannerDayCounselByPlanner[] = counselsMy;

  return {
    counsels,
    isLoading,
    error,
    regionIds,
    regionIdsLoading,
    workDates,
    isWorkDatesLoaded,
    geoJson,
    geoJsonLoading,
    serviceRegions,
    serviceRegionsLoading,
  };
}
